import * as React from "react";
import { Consumer } from "../libs/AuthContext";
import { Button, Header, Icon } from "semantic-ui-react";
import "./Sidebar.css";

class Sidebar extends React.Component {

 constructor(props) {
   super(props);
   this.pubLoader = null;
   this.state = {
     navCollections: []
   }
 }

async componentDidMount() {
   this.pubLoader = this.props.context.pubLoader;
   let engine = this.pubLoader.getEngine();
   let readerPublication = engine.getReaderPublications()[0];
   readerPublication.fetchPublicationNavigation().then(navDocument => {
       this.setState({ navCollections: navDocument.getNavigationCollections()})
   })
 }

  async componentWillUnmount() {
   this.setState({navCollections: []})
 }

 showChildren = id => {
   let x = document.getElementById(id+"child")
   let children = x.childNodes;
   if (x.classList.contains("inactive")){
     x.classList.remove("inactive");
     x.classList.add("child")
     children.forEach((child) => {
       child.classList.contains("inactive") && child.classList.remove("inactive") ;
       child.classList.add("child")
       let button = child.childNodes[0]
       button.classList.contains("inactive") && button.classList.remove("inactive") ;
       button.classList.add("sideButtons")
     })
   }
   else if  (x.classList.contains("child")) {
     x.classList.remove("child");
     x.classList.add("inactive")
     children.forEach((child) => {
       child.classList.contains("child") && child.classList.remove("child") ;
       child.classList.add("inactive")
       let button = child.childNodes[0]
       button.classList.contains("sideButtons") && button.classList.remove("sideButtons") ;
       button.classList.add("inactive")
     })
   }
   let right = document.getElementById(id+"right");
   let down = document.getElementById(id+"down");
   if (right.classList.contains("active")) {
     right.classList.remove("active");
     right.classList.add("inactive")
   }
   else if (right.classList.contains("inactive")){
     right.classList.remove("inactive");
     right.classList.add("active")
   }
   if (down.classList.contains("active")) {
     down.classList.remove("active");
     down.classList.add("inactive")
   }
   else if (down.classList.contains("inactive")){
     down.classList.remove("inactive");
     down.classList.add("active")
   }
 }

goToItem = elem => {
   const view = this.pubLoader.getView();
     view.goTo(elem.annotationTarget).then(() => {
       //this.pubLoader.setView(view);
     }).catch(err => {
         console.error(err);
     });
 }
  visit(navElement) {
   return [{}].concat(navElement).map(
     (elem, index) =>
       index !== 0
       ?
       <div key={index}>
         {elem.children ?
           <div>
             <div style={{display: "flex"}}>
               <Button icon onClick={() => {this.showChildren(elem.textContent)}} id={elem.textContent+"right"} className="active">
                 <Icon name="caret right" inverted />
               </Button>
               <Button icon onClick={() => {this.showChildren(elem.textContent)}} id={elem.textContent+"down"} className="inactive">
                 <Icon name="caret down" inverted/>
               </Button>
               <Button onClick={() => {this.goToItem(elem)}} className="sideButtons">
                   {elem.textContent}
               </Button>
             </div>
             <div className="inactive" id={elem.textContent+"child"}>
               {this.visit(elem.children)}
             </div>
           </div>
           :
             <Button onClick={() => {this.goToItem(elem)}} className="sideButtons">
                 {elem.textContent}
             </Button>
         }
       </div>
       :
       null
   )

}
 renderList() {
   return [{}].concat(this.state.navCollections).map(
     (navElement, index) =>
       index !== 0
       ?
         <div key={index}>
             <Header as="h3" style={{color: "white"}}>{navElement.title}</Header>
             {navElement.children &&
               this.visit(navElement.children)
             }
         </div>
       : null
   );
 }


 render()  {
   return (
     <div>
         {this.renderList()}
     </div>
   )
 }
}
export default (props => (
 <Consumer>
   {value => <Sidebar {...props} context={value} />}
 </Consumer>
))
